import vuetify from '../plugins/vuetify'

export const useVuetify = () => {
  const getColor = (color: string) => vuetify.framework.theme.themes.light[color]

  return {
    getColor,
    vuetify
  }
}